import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "flex"
};
const _hoisted_2 = {
  class: "ic"
};
const _hoisted_3 = {
  key: 1,
  class: "iconfont icon-info"
};
const _hoisted_4 = {
  class: "flex-body"
};
const _hoisted_5 = {
  class: "error"
};
const _hoisted_6 = {
  class: "text-left"
};
const _hoisted_7 = ["innerHTML"];
import { useOverlayStore } from "@/stores";
import { configuratorOpenState } from "@/stores/configuratorOpenState";
import { useAdditionalAttrStore } from "@/stores/AdditionalAttrStore";
import { computed } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'OpenConfiguratorModel',
  setup(__props) {
    const modelClass = computed(() => {
      if (additionalAttrStore.modelConfig.type) {
        return "configurator-popup configurator-popup-" + additionalAttrStore.modelConfig.type;
      }
      return "configurator-popup";
    });
    const cos = configuratorOpenState();
    const overlayStore = useOverlayStore();
    const additionalAttrStore = useAdditionalAttrStore();
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(overlayStore).isModelVisible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(overlayStore).isModelVisible = $event),
        "destroy-on-close": "",
        "close-on-press-escape": _unref(additionalAttrStore).modelConfig.allowClose,
        "close-on-click-modal": _unref(additionalAttrStore).modelConfig.allowClose,
        "show-close": _unref(additionalAttrStore).modelConfig.allowClose,
        "append-to-body": true,
        "modal-class": modelClass.value,
        width: "808px",
        center: true,
        onClose: _cache[1] || (_cache[1] = () => {
          _unref(cos).setOpenModal(false);
          _unref(overlayStore).toggleModelOverlay();
        })
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_unref(additionalAttrStore).modelConfig.type === 'error' ? (_openBlock(), _createBlock(_component_svg_icon, {
          key: 0,
          "icon-class": "alert-white"
        })) : (_openBlock(), _createElementBlock("i", _hoisted_3))]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
          innerHTML: _unref(additionalAttrStore).modelConfig.content
        }, null, 8, _hoisted_7)])])])])]),
        _: 1
      }, 8, ["modelValue", "close-on-press-escape", "close-on-click-modal", "show-close", "modal-class"]);
    };
  }
});